import React, { useRef } from 'react'
import { useGSAP } from '@gsap/react'
import { createIntroTimeline } from './IntroTimeline'
import './IntroEngine.css'

interface IntroEngineProps {
  onComplete: () => void;
  isAppReady?: boolean;
}

const IntroEngine: React.FC<IntroEngineProps> = ({ onComplete, isAppReady = true }) => {
  const root = useRef<HTMLDivElement>(null)

  // نمرر المصفوفة فارغة لمنع اعادة تشغيل GSAP عند تغير Props
  useGSAP(
    () => {
      createIntroTimeline(root.current!, onComplete, isAppReady)
    },
    { scope: root }
  )

  const techKeywords = [
    'ERP_SYSTEM', 'DASHBOARD', 'SAAS_APP', 'API_READY', 'REACT_19', 'LARAVEL_11',
    'CONTROL_PANEL', 'BILLING_SYS', 'WEB_APP', 'DATABASE', 'CRM_MODULE', 'E-COMMERCE'
  ];

  return (
    <div ref={root} className="lx-intro">
      <div className="lx-stream-container">
        {Array.from({ length: 16 }).map((_, i) => (
          <span key={i} className="lx-stream-item">
            {techKeywords[i % techKeywords.length]}
          </span>
        ))}
      </div>
  
      <div className="lx-curtain">
        <div className="lx-background" />
      </div>
  
      <div className="lx-portal-ring">
        <svg className="lx-loading-svg" viewBox="0 0 200 200">
          <defs>
            <linearGradient id="lx-neon-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#8c6b16" />
              <stop offset="50%" stopColor="#e8c563" />
              <stop offset="100%" stopColor="#a9821e" />
            </linearGradient>
          </defs>
          <circle className="track" cx="100" cy="100" r="92" />
          <circle className="glow-bar" cx="100" cy="100" r="92" />
        </svg>
      </div>
  
      <div className="lx-center">
        <h1 className="lx-logo" dir="ltr">
          <span className="b">B</span>
          <span className="a">A</span>
          <span className="d">D</span>
          <span className="a">A</span>
          <span className="n">N</span>
          <span className="i">I</span>
          <span className="b">B</span>
          <span className="e">E</span>
          <span className="x">X</span>
        </h1>
      </div>
  
      <div className="lx-counter">
        <span className="counter-value">000</span>
        <span className="counter-label">SYSTEM_READY</span>
      </div>
    </div>
  )
}

export default IntroEngine